import { Button, CircularProgress, Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { ErrorAlert } from '../../components/atoms/Alert-message';
import TrackingFilePage from '../../components/trackingFile/TrackingFilePage';
import { APIHeader } from '../../index';
import { createGetOverviewOptions } from '../../queries/overviewQueries';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import {
  TrackingInfoDrivers,
  homeButtonComponent,
  pageGrid,
  titleName,
} from '../../styles';
import { getDownloadLink } from '../../utils';

//Tracking File Component
const TrackingFile = props => {
  const { apiConfig, userInfo, errorInAPI } = props;
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const pecrId = searchParams.get('id');
  const dispatch = useDispatch();

  const { data: overviewData, isLoading } = useQuery(
    createGetOverviewOptions({ pecrId }, { enabled: !!pecrId })
  );

  const onDownloadExcelClick = () => {
    fetch(`${apiConfig.uiURL}api/DownloadExcel`, {
      method: 'POST',
      headers: APIHeader(),
      body: JSON.stringify({
        PID: pecrId,
      }),
    })
      .then(async response => {
        response.blob().then(blob => {
          getDownloadLink(blob, `${pecrId.toString()}.xlsx`);
        });
      })
      .catch(() => {
        dispatch(
          errorNotification({
            hasErrorOccured: true,
            message: t('error_message'),
          })
        );
      });
  };
  if (errorInAPI.hasErrorOccured) {
    return <ErrorAlert message={errorInAPI.message} />;
  }

  if (isLoading) {
    return (
      <Grid style={homeButtonComponent}>
        <CircularProgress />
      </Grid>
    );
  }

  return (
    <Grid style={pageGrid}>
      <Grid style={TrackingInfoDrivers} container>
        <Grid>
          <h4 style={titleName}>{t('PECR_Summary')}</h4>
        </Grid>
        <Grid>
          <Button
            variant="contained"
            onClick={onDownloadExcelClick}
            style={{ textTransform: 'none', fontSize: '18px' }}
          >
            {t('Download_Excel')}
          </Button>
        </Grid>
      </Grid>
      <TrackingFilePage />
      {/* <TrackingFileSummary /> */}
    </Grid>
  );
};

const mapStateToProps = (state = {}) => {
  return {
    userInfo: state.userInfo,
    errorInAPI: state.errorNotification,
  };
};
export default connect(mapStateToProps, null)(TrackingFile);
